import { motion } from 'framer-motion'

// Replace with actual corporate client logos (experience from employment, consulting, or other ventures)
const clients = [
  { id: 1, logo: '/assets/logo-kleenheat.svg' },
  { id: 2, logo: '/assets/logo-evollng.svg' },
  { id: 3, logo: '/assets/logo-wesfarmers.svg' },
  { id: 4, logo: '/assets/logo-crown.svg' },
  { id: 5, logo: '/assets/logo-csbp.svg' },
  { id: 6, logo: '/assets/logo-shell.svg' },
  { id: 7, logo: '/assets/logo-wescef.svg' },
]

export default function Clients() {
  return (
    <section id="clients" className="relative py-16 md:py-20 bg-slate-50 border-t border-slate-200 overflow-hidden">
      <div className="container relative z-10">
        <div className="mx-auto max-w-3xl text-center mb-12">
          <h2 className="text-xs font-bold text-accent uppercase tracking-[0.2em] mb-3">Our Background</h2>
          <h3 className="text-2xl md:text-3xl font-bold font-heading text-primary uppercase tracking-tight mb-4">
            Big fish <span className="text-accent">Experience.</span> 
          </h3>
          <p className="text-base text-slate-600 leading-relaxed max-w-xl mx-auto">
            Our team brings hands-on expertise from some of the world's biggest and most respected brands — across a range of roles and engagements.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex flex-wrap items-center justify-center gap-x-12 gap-y-8 md:gap-x-16 md:gap-y-10"
        >
          {clients.map((client) => (
            <div
              key={client.id}
              className="flex items-center justify-center w-24 h-16 md:w-28 md:h-20 grayscale opacity-60 hover:opacity-100 hover:grayscale-0 transition-all duration-300"
            >
              <img
                src={client.logo}
                alt=""
                className="w-full h-full object-contain"
                aria-hidden
              />
            </div>
          ))}
        </motion.div>

        <hr className="border-slate-200 my-10 max-w-md mx-auto" />

        <p className="text-center text-base text-accent font-bold">
          Enterprise-grade strategy for challenger brands — maximum impact, scaled to fit your budget.
        </p>
      </div>
    </section>
  )
}
